import { Component, Vue } from 'vue-property-decorator'
import { getCustomerConversionFollowListByCustomerConversionId }  from '@/api/customer'
import {getMessageRemindById} from "@/api/message";

@Component({})
export default class FollowRecord extends Vue {
    tableData = []
    page = 1
    limit = 20
    total = 0
    id: number;
    loading = false
    fsnumShow = true
    types = ''
    logList = []
    culesInfoShow = false
    customerInfoShow = true
    infoData = []

    created() {

        //  获取地址栏里的参数
        const url = window.location.href
        const p = url.split('?')[1]
        const params = new URLSearchParams(p)
        const recordId = params.get('id')
        this.types = this.$route.query.types ? this.$route.query.types as string : ''
        this.getMsgData(recordId)
    }
    async getMsgData(id) {
        const data: any = await getMessageRemindById({id: id})
        this.infoData = data.result.messageRemindInfo
        this.tableData = data.result.messageRemindInfo.customerConversionFollowList
        this.logList = data.result.messageRemindInfo.financeRepeatOrderLogList

    }


    onOpen(url: string) {
        window.open(url, '_blank')
    }
}
